import { useNotificationsStore } from "../../stores/NotificationsStore/NotificationsStore";
import NotificationItem from "./NotificationItem";
import s from "./NotificationItems.module.scss";

const NotificationItems = () => {
  const { components, removeComponent, title, status, setTitle, setStatus } =
    useNotificationsStore();

  return (
    <div className={s.notifications}>
      {components.map((comp) => (
        <NotificationItem
          key={comp.id}
          id={comp.id}
          onRemove={removeComponent}
          title={title}
          status={status}
          setTitle={setTitle}
          setStatus={setStatus}
        />
      ))}
    </div>
  );
};

export default NotificationItems;
